// @flow

import { get } from 'lodash';
import type { Service } from '@zapier/services/src/types';

export default function isServiceHidden(service: Service) {
  return service.isHidden || get(service, 'hidden');
}
